/* global MI, AbstractSymbol */

import {arrayCircleGetIndex} from "../utils/helpers";

/**
 * @constructor
 * @returns {SpinReel}
 */
export function SpinReel() {

	/** @type {number} */
	this.id;

	/** @type {GameConfig} */
	this._gameConfig;

	/** @type {SymbolsManager} */
	this._symbolsManager;

	/** @type {ReelPrinter} */
	this._printer;

	/** @type ReelMotion */
	this.motion;

	/** @type {Array<AbstractSymbol>} */
	this.symbols = []; //array of actual reel symbols (objects) //3lines => 5 symbols

	/** @type {Array<AbstractSymbol>} */
	this.spinSymbols = []; //array of all reel symbols (objects)

	/** @type {Array<AbstractSymbol>} */
	this.resSymbols = []; //array of displyed symbols (3 lines -> 3 symbols)

	/** @type {Array<AbstractSymbol>} */
	this.tmpSymbols = []; //copy of reelsSymbols

	/** @type {Array<AbstractSymbol>} */
	this.failSymbols = [];

	this._allMatrix = []; //server_config.logic.reels
	this._reelMatrix = []; //server_config.matrix.reelMatrix;
	this._failMatrix = []; //server_config.logic.failResult

	this.symbolPosition = 0;

	this.shiftY = 0;

	/** @type {Storm} */
	this.storm;

	this._symbolsScale = 1;
}

SpinReel.prototype.setScale = function(scale) {
	this._symbolsScale = scale;
};

/**
 * @param {number} id
 * @param {GameConfig} gameCfg
 * @param {SymbolsManager} symbolsManager
 * @param {ReelPrinter} printer
 * @param {ReelMotion} motion
 * @returns {undefined}
 */
SpinReel.prototype.init = function(id, gameCfg, symbolsManager, printer, motion) {
	this.id = id;
	this._gameConfig = gameCfg;
	this._symbolsManager = symbolsManager;
	this._printer = printer;

	this.motion = motion;
};

SpinReel.prototype.setAllMatrix = function(symbolsNum) {
	this._allMatrix = symbolsNum; //.slice(0, 1);
};

SpinReel.prototype.getAllMatrix = function() {
	return this._allMatrix;
};

SpinReel.prototype.setReelMatrix = function(matrix) {
	this._reelMatrix = matrix;
};

SpinReel.prototype.getReelMatrix = function() {
	return this._reelMatrix;
};

SpinReel.prototype.setFailMatrix = function(matrix) {
	this._failMatrix = matrix;
};

SpinReel.prototype.getFailMatrix = function() {
	return this._failMatrix;
};

SpinReel.prototype.getFailSymbols = function() {
	return this.failSymbols;
};

SpinReel.prototype.setSymbolPosition = function(pos) {
	this.symbolPosition = pos ? pos : 0;
};

/** @returns {Array} */
SpinReel.prototype.getSpinSymbols = function() {
	return this.spinSymbols;
};

SpinReel.prototype.create = function(group) {

	this.createSpinSymbols(group);
	this.initResSymbols(group);
	this.createResSymbols();
	this.initSymbols();
};

SpinReel.prototype.reinitPositions = function() {

	for(var i = 0; i < this.spinSymbols.length; i++) {
		this.spinSymbols[i].setPosY(-9999);
	}

	this._printer.print(this);
};

/**
 * Creates reels blurred symbols (not win symbols)
 * @param {MadnesGroup} group
 */
SpinReel.prototype.createSpinSymbols = function(group) {
	var i = this.id;
	var x = this._gameConfig.reelsPositions[i]["x"];

	for(var j = 0; j < this._allMatrix.length; j++) {

		var symbol = this._symbolsManager.create(this._allMatrix[j], x, -9999, i, j);
		symbol.setVisible(false);
		symbol.createBlurSymbol();

		if(this._symbolsScale !== 1) {
			symbol.setScale(this._symbolsScale, this._symbolsScale);
		}

		group.add(symbol);

		this.spinSymbols[j] = symbol;
	}
};

SpinReel.prototype.killResSymbols = function() {
	for(var i = 0; i < this.resSymbols.length; i++) {
		this.resSymbols[i].kill();
	}
};

SpinReel.prototype.killSpinSymbols = function() {
	for(var i = 0; i < this.spinSymbols.length; i++) {
		this.spinSymbols[i].kill();
	}
};

SpinReel.prototype.killAllSymbols = function() {
	this.killSpinSymbols();
	this.killResSymbols();
};

SpinReel.prototype.reviveSpinSymbols = function() {
	for(var i = 0; i < this.spinSymbols.length; i++) {
		this.spinSymbols[i].revive();
	}
};

SpinReel.prototype.reviveResSymbols = function() {
	for(var i = 0; i < this.resSymbols.length; i++) {
		this.resSymbols[i].revive();
	}
};

SpinReel.prototype.reviveAllSymbols = function() {
	this.reviveSpinSymbols();
	this.reviveResSymbols();
};

SpinReel.prototype.setTmpSymbols = function() {
	for(var j = 0; j < this.resSymbols.length; j++) {
		this.tmpSymbols.push(this.resSymbols[j]);
	}
};

SpinReel.prototype.removeTmpSymbols = function() {
	for(var i = 0; i < this.tmpSymbols.length; i++) {
		this.tmpSymbols[i].destroy();
	}

	this.tmpSymbols.length = 0;
};

SpinReel.prototype.removeHidedSymbols = function() {

	//this.destroySpinSymbols();
	this.killSpinSymbols();

	/*this.symbols[this.symbols.length - 1].destroy();
	this.symbols[this.symbols.length - 1] = null;

	this.symbols[0].destroy();
	this.symbols[0] = null;*/
};

SpinReel.prototype.initSymbols = function() {

	if(this.spinSymbols.length > 0) {
		this.symbols[0] = this.spinSymbols[arrayCircleGetIndex(this._allMatrix, this.symbolPosition)];
		this.symbols[0].setVisible(false);

		this.symbols[this.resSymbols.length + 1] = this.spinSymbols[arrayCircleGetIndex(this._allMatrix, this.symbolPosition - 1)];
		this.symbols[this.resSymbols.length + 1].setVisible(false);
	}

	for(var j = 0; j < this.resSymbols.length; j++) {
		this.symbols[j + 1] = this.resSymbols[j];
	}
};

SpinReel.prototype.initTmpSymbols = function() {

	if(this.spinSymbols.length > 0) {
		this.symbols[0] = this.spinSymbols[arrayCircleGetIndex(this._allMatrix, this.symbolPosition)];
		this.symbols[0].setVisible(false);

		this.symbols[this.resSymbols.length + 1] = this.spinSymbols[arrayCircleGetIndex(this._allMatrix, this.symbolPosition - 1)];
		this.symbols[this.resSymbols.length + 1].setVisible(false);
	}

	for(var j = 0; j < this.tmpSymbols.length; j++) {
		this.symbols[j + 1] = this.tmpSymbols[j];
	}
};

SpinReel.prototype.clearResSymbols = function() {
	this.resSymbols.length = 0;
};

/**
 * Initializes reel symbols after result load
 * @param {MadnesGroup} group
 */
SpinReel.prototype.initResSymbols = function(group) {
	var i = this.id;
	var x = this._gameConfig.reelsPositions[i]["x"];

	this.resSymbols = [];

	for(var j = 0; j < this._reelMatrix.length; j++) {

		this.resSymbols[j] = this._symbolsManager.create(this._reelMatrix[j], x, -9999, i, j);

		group && group.add(this.resSymbols[j]);
	}
};

SpinReel.prototype.createResSymbols = function() {
	for(var j = 0; j < this.resSymbols.length; j++) {
		this.resSymbols[j].createSymbol();

		if(this._symbolsScale !== 1) {
			this.resSymbols[j].setScale(this._symbolsScale, this._symbolsScale);
		}
	}
};

/**
 * @param {Array<MadnesObject>} symbols
 * @param {MadnesGroup=} group
 */
SpinReel.prototype.createBlurSymbols = function(symbols, group) {
	for(var i = 0; i < symbols.length; i++) {
		symbols[i].createBlurSymbol();

		if(this._symbolsScale !== 1) {
			symbols[i].setScale(this._symbolsScale, this._symbolsScale);
		}

		group && group.add(symbols[i]);
	}
};

/**
 * @param {MadnesGroup=} group
 */
SpinReel.prototype.createBlurTmpSymbols = function(group) {
	//var i = this.id;
	//var x = this._gameConfig.reelsPositions[i]["x"];

	this.createBlurSymbols(this.tmpSymbols, group);
};

SpinReel.prototype.start = function() {
	this.started = true;
	return this.motion.start();
};

SpinReel.prototype.stop = function() {
	this.started = false;
	return this.motion.stop();
};

SpinReel.prototype.addSymbolsToStop = function(count) {
	this.motion.addSymbolsToStop(count);
};

SpinReel.prototype.onSpin = function(func) {
	this.motion.onSpin(func);
};

SpinReel.prototype.onStop = function(func) {
	this.motion.onStop(func);
};

SpinReel.prototype.onBrakeDown = function(func) {
	this.motion.onBrakeDown(func);
};

SpinReel.prototype.onBrakeUp = function(func) {
	this.motion.onBrakeUp(func);
};

SpinReel.prototype.visibleResSymbols = function(bool) {
	for(var i = 0; i < this.resSymbols.length; i++) {
		this.resSymbols[i].setVisible(bool);
	}
};

SpinReel.prototype.clearSymbols = function() {
	for(var i = 0; i < this.resSymbols.length; i++) {
		this.resSymbols[i].clear();
	}
};

SpinReel.prototype.createSymbols = function() {
	for(var i = 0; i < this.resSymbols.length; i++) {
		this.resSymbols[i].createSymbol();

		if(this._symbolsScale !== 1) {
			this.resSymbols[i].setScale(this._symbolsScale, this._symbolsScale);
		}
	}
};

SpinReel.prototype.showInvisibleSymbols = function() {
	this.symbols[0].setVisible(true);
	this.symbols[this.symbols.length - 1].setVisible(true);
};

SpinReel.prototype.hideInvisibleSymbols = function() {
	this.symbols[0].setVisible(false);
	this.symbols[this.symbols.length - 1].setVisible(false);
};

SpinReel.prototype.hasScatter = function() {
	for(var i = 0; i < this.resSymbols.length; i++) {

		if(this.resSymbols[i].symbolName === "symbol_Scatter") {
			return true;
		}
	}

	return false;
};

SpinReel.prototype.destroy = function() {

	for(var i = 0; i < this.spinSymbols.length; i++) {
		this.spinSymbols[i].destroy();
	}
	this.spinSymbols.length = 0;

	for(var i = 0; i < this.resSymbols.length; i++) {
		this.resSymbols[i].destroy();
	}
	this.resSymbols.length = 0;

	for(var i = 0; i < this.failSymbols.length; i++) {
		this.failSymbols[i].destroy();
	}
	this.failSymbols.length = 0;

	for(var i = 0; i < this.symbols.length; i++) {
		this.symbols[i].destroy();
	}
	this.symbols.length = 0;

	this._allMatrix.length = 0;
	this._reelMatrix.length = 0;
	this._failMatrix.length = 0;

	this.motion && this.motion.destroy();

};